import { render } from "./HoldingTable.vue?vue&type=template&id=3831794c"
import script from "./HoldingTable.vue?vue&type=script&lang=js"
export * from "./HoldingTable.vue?vue&type=script&lang=js"

import "./HoldingTable.vue?vue&type=style&index=0&id=3831794c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__